.overlay {
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 100000;
}

.dialog {
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  max-height: calc(100vh - 2rem);
  max-width: 900px;
  overflow-y: auto;
  padding: 1rem;
  position: relative;
  width: min(75%, 900px);
  z-index: 100001;
}

.header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.title {
  font-size: 1.25rem;
  font-weight: 700;
}

.closeButton {
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-flex;
  margin-left: 0.5rem;
  padding: 0;
}

.content {
  width: 100%;
}
